import * as rudderanalytics from 'rudder-sdk-js';

// src/Tracker.ts
var RUDDERSTACK_DATA_PLANE_URL = "https://aircall-dataplane.rudderstack.com";
var TRACKER_ENVIRONMENT = /* @__PURE__ */ ((TRACKER_ENVIRONMENT2) => {
  TRACKER_ENVIRONMENT2["DEVELOPMENT"] = "development";
  TRACKER_ENVIRONMENT2["TEST"] = "test";
  TRACKER_ENVIRONMENT2["STAGING"] = "staging";
  TRACKER_ENVIRONMENT2["BETA"] = "beta";
  TRACKER_ENVIRONMENT2["PRODUCTION"] = "production";
  return TRACKER_ENVIRONMENT2;
})(TRACKER_ENVIRONMENT || {});
var defaultIdentification = {
  user_id: 0,
  created_at: "",
  release: "default",
  device: "",
  email: "",
  is_admin: false,
  name: "",
  platform: "default",
  environment: "development" /* DEVELOPMENT */,
  language: ""
};
var Tracker = class {
  constructor(options) {
    this.options = options;
    this.analytics = rudderanalytics;
  }
  context;
  analytics;
  identified = false;
  identification = defaultIdentification;
  // Getter to check if we are in development environment
  get isDevelopment() {
    return this.identification.environment === "development" /* DEVELOPMENT */;
  }
  // Getter to check if the module is identified with user's information
  get isIdentified() {
    return this.identified;
  }
  // Getter to access the RudderStack SDK
  get sdk() {
    return this.analytics;
  }
  // Init the module by dynamically injecting the RudderStack SDK
  init() {
    this.analytics.load(this.options.key, RUDDERSTACK_DATA_PLANE_URL);
  }
  // Identify user with TrackerIdentification
  identify(identification) {
    this.sdk?.identify(identification.user_id.toString(), identification);
    this.identification = identification;
    this.identified = true;
  }
  /**
   * Store the context into the class
   * @param context
   */
  addContext(context) {
    this.context = context;
  }
  /**
   * Track an event.
   * Add the local context to the given property.
   * Log it in the console when in development mode, send it to RudderStack otherwise.
   * @param message
   * @param properties
   */
  track(message, properties = {}) {
    const propertiesWithContext = { ...properties, ...this.context };
    if (this.isDevelopment) {
      console.log("TRACK", message, propertiesWithContext);
    } else {
      this.sdk?.track(message, propertiesWithContext);
    }
  }
  /**
   * Record a page view event
   * Add the local context to the given property.
   * Log it in the console when in development mode, send it to RudderStack otherwise.
   * @param options
   */
  page(properties = {}) {
    const propertiesWithContext = { ...properties, ...this.context };
    if (this.isDevelopment) {
      console.log("PAGE", propertiesWithContext);
    } else {
      this.sdk?.page(propertiesWithContext);
    }
  }
  // Resets the id, including anonymousId, and clears traits for the currently identified user
  reset() {
    this.sdk?.reset();
  }
};

// src/actions.ts
var TRACKER = /* @__PURE__ */ ((TRACKER2) => {
  TRACKER2["INIT"] = "TRACKER_INIT";
  TRACKER2["TRACK"] = "TRACKER_TRACK";
  TRACKER2["PAGE"] = "TRACKER_PAGE";
  return TRACKER2;
})(TRACKER || {});
var initTracker = () => ({
  type: "TRACKER_INIT" /* INIT */
});
var track = (message, properties = {}) => ({
  type: "TRACKER_TRACK" /* TRACK */,
  message,
  properties
});
var page = (properties = {}) => ({
  type: "TRACKER_PAGE" /* PAGE */,
  properties
});

export { TRACKER, TRACKER_ENVIRONMENT, Tracker, defaultIdentification, initTracker, page, track };
